import { FC } from "react"
import images from "../../assets/loaders/imageLoader"
import { Paths } from "../../routes/paths"

const Footer: FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-semibold mb-4">Tierras del Paraná</h3>
            <p className="text-gray-400">
              Desarrolladora inmobiliaria
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li><a href={Paths.home} className="link text-gray-400 hover:text-white">Inicio</a></li>
              {/* <li><a href={Paths.projects} className="text-gray-400 hover:text-white">Proyectos</a></li> */}
              {/* <li><a href={Paths.about} className="text-gray-400 hover:text-white">Nosotros</a></li> */}
              {/* <li><a href="#contact-us" className="text-gray-400 hover:text-white">Contacto</a></li> */}
            </ul>
          </div>
          <div className="space-y-2">
            <h3 className="text-xl font-semibold mb-4">Contacto</h3>
            <a
              className="flex items-center text-gray-400 hover:text-white -ml-3"
              href={`https://wa.me/5493433022876?text=Hola, quiero contactarme.`}
              target="_blank"
            >
              <img className="w-12 h-auto inline-block" src={images.whatsappSvg} alt="WhatsApp" />
              +54 343 3 022876
            </a>
            <a href="mailto:informacion@tierrasdelparana.com.ar" className="text-gray-400 hover:text-white">
              informacion@tierrasdelparana.com.ar
            </a>
            <p className="text-gray-400 mb-2">
              Andrade 109, Paraná, Argentina
            </p>
          </div>
          <div className="space-y-2">
            <h3 className="text-xl font-semibold mb-4">Síguenos</h3>
            <div className="flex">
              <a href="https://www.instagram.com/tierrasdelparana/" className="text-gray-400 hover:text-white -ml-3" target="_blank">
                <img className="w-12 h-auto" src={images.instagramSvg} alt="Instagram" />
              </a>
              <a href="https://twitter.com/tierrasdelparan" className="text-gray-400 hover:text-white -ml-3" target="_blank">
                <img className="w-12 h-auto" src={images.twitterSvg} alt="Twitter" />
              </a>
              <a href="https://www.facebook.com/TierrasDelParana/?locale=es_LA" className="text-gray-400 hover:text-white -ml-3" target="_blank">
                <img className="w-12 h-auto" src={images.facebookSvg} alt="Facebook" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-4 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Tierras del Paraná. Todos los derechos reservados. Desarrollado por <a href="https://www.linkedin.com/in/neckell/" target="_blank" className="link">neckell</a></p>
        </div>
      </div>

    </footer>
  )
}

export default Footer
